import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { ISearchCountModel } from '@apps-common/types/general'

export const QUERY_KEY_PORTAL_GET_TRAFFIC_DAILY_COUNT = (status?: string, id?: string) =>
  ['getTrafficDailyCount', status, id].filter(Boolean)

export const getTrafficDailyCount = async (status: string, id: string): Promise<ISearchCountModel> =>
  axios.get(`/Unit/GetUnitTrafficDailyCount?status=${status}&unitId=${id}`).then((res) => res.data?.data)

type QueryFnType = typeof getTrafficDailyCount

type Props = {
  config?: QueryConfig<QueryFnType>
  status: string
  id: string
}

export const usePortalGetTrafficDailyCount = ({ config, status, id }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: QUERY_KEY_PORTAL_GET_TRAFFIC_DAILY_COUNT(status, id),
    queryFn: () => getTrafficDailyCount(status, id)
  })
